package com.gsb.vyapar.bhagya.presentation.bottomsheet.util

import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.updateState
import com.gsb.vyapar.bhagya.presentation.bottomsheet.BottomSheets

fun showBottomSheet(bottomSheets: BottomSheets) {
    updateState(getState().copy(bottomSheetView = bottomSheets))
}

fun hideBottomSheet() {
    updateState(getState().copy(bottomSheetView = null))
}